import Vue from 'vue';
import Vuex from 'vuex';

import code from '@/store/code';
import user from '@/store/user';
import antagonist from '@/store/antagonist';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    code,
    user,
    antagonist,
  },
});
